/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import linea from '../../../Recursos/lineas.svg'
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Portada = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'center', mt: 2}}>
                            <Typography
                                sx={{
                                    background: 'linear-gradient(90deg, #8531FD 0%, #7A1CFF 51.92%, #7CF0FF 90.87%)',
                                    backgroundClip: 'text',
                                    color: '#00000000',
                                    fontSize: sCell ? 28 : 44,
                                    fontWeight: 800,
                                    lineHeight: 1.1,
                                    textAlign: 'center'
                                }}
                            >
                                Sistema de Formación Empresarial
                                <br />
                                Nebo System
                            </Typography>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                            <Typography
                                sx={{
                                    fontFamily: 'Inter',
                                    fontSize: sCell ? 24 : 24,
                                    fontWeight: 800,
                                    color: '#262626'
                                }}
                            >By Team Tufiño</Typography>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', mt: 0, ml: sCell ? -10 : -14}}>

                            <img src={linea} width={sCell ? 60 : 70} height={'auto'}/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Portada